import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseMiscApiService } from '@common/api/base-misc-api.service';

import { TemplateApi, ScheduleDescriptionApi } from './models';
import { AppConstants } from '../../app.constants';

@Injectable({
    providedIn: 'root'
})
export class TemplatesMiscApiService extends BaseMiscApiService
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlRept;
        this.segmentApi = '/rept/templates';
    }

    getTemplates (): Observable<TemplateApi[]>
    {
        return this.http.get<TemplateApi[]>(`${this.segmentRoot}${this.segmentApi}`);
    }

    getTemplateFromReportId (reportId: string): Observable<TemplateApi>
    {
        return this.http.get<TemplateApi>(`${this.segmentRoot}${this.segmentApi}/${reportId}`);
    }

    getNextSchedule (scheduleDescription: ScheduleDescriptionApi): Observable<string>
    {
        return this.post<string>('/nextschedule', scheduleDescription)
            .pipe(
                map((obj: any): string =>
                    obj.nextSchedule
                )
            );
    }
}
